import { useAdditionalFee } from "@/components/features/items/edit/hotel-policy/_shared/components/main/question/additional-fee/hooks";

import { useAccommodationHotelPolicyI18nFormModelContext } from "../../../../../context";

export const useReservationAdditionalFee = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyI18nFormModelContext();
	const { additionalFees } = viewModel;

	return useAdditionalFee({ additionalFees, onSetViewModel });
};
